export const multiSelectStyles = (sm: boolean) => ({
  root: {
    '& .MuiInput-formControl': {
      marginTop: '0.19rem',
    },
    '& .MuiInputBase-root': {
      paddingTop: '0.17rem',
      paddingBottom: '0.29rem',
      display: 'flex',
      justifyContent: 'space-between',
      ...(!sm && { flexDirection: 'column' }),
    },
    '& .MuiSelect-select': {
      marginTop: '-0.32rem',
      display: 'flex',
      flexWrap: 'wrap',
      width: 'auto',
      maxWidth: !sm ? 'calc(100% - 1.5rem)' : 'min(calc(60% - 1.5rem), 50vw)',
      paddingBottom: '6px',
      paddingTop: '12px',
      ...(!sm && { paddingLeft: '20px' }),
    },
    '& .MuiSelect-icon': {
      marginTop: !sm ? '.6rem' : '-.03rem',
    },
    '& .MuiInputAdornment-root': {
      marginTop: !sm ? '.1rem' : '-.15rem',
      ...(!sm && {
        alignSelf: 'flex-start',
        marginBottom: '.4rem',
      }),
    },
  },
});
